import React from "react";
import LeftSidebarMenu from "../../../shared/Layout/LeftSidebarMenu";

function LeftNavigation({ toggleActive }) {
  return (
    <LeftSidebarMenu
      menuSections={[
        {
          title: "Сторінки",
          items: [
            {
              label: "Дашборд",
              path: "/management/dashboard",
              icon: "dashboard",
              resource: "management.dashboard",
            },
            {
              label: "Оператори",
              path: "/management/operators/",
              icon: "person_outline",
              resource: "management.operators",
            },
            {
              label: "Скрипти",
              path: "/management/scripts/",
              icon: "contact_page",
              resource: "management.scripts",
            },
            {
              label: "Графік роботи",
              path: "/management/work-schedule/",
              icon: "date_range",
              resource: "management.work_schedule",
            },
            {
              label: "Графік супервайзерів",
              path: "/management/supervisor-work-schedule/",
              icon: "calendar_view_week",
              resource: "management.supervisor_work_schedule",
            },
            {
              label: "Звільнені люди",
              path: "/management/freed-people/",
              icon: "lock",
              resource: "management.freed_people",
            },
            {
              label: "CRM",
              path: "/management/crms",
              icon: "business",
              resource: "management.crm",
            },
          ],
        },
      ]}
      toggleActive={toggleActive}
    />
  );
}

export default LeftNavigation;
